import { createApp } from 'vue';
import App from './App.vue';
// Vuetify 스타일
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/styles/style.scss';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import router from './router';
import { createPinia } from 'pinia';
import { vuetify } from '@/utils';

createApp(App)
  .use(vuetify)
  .use(router)
  .use(createPinia())
  .component('VueDatePicker', VueDatePicker)
  .mount('#app');
